<template>
  <div v-scroll="onScroll" v-resize="onResize">
    <v-row no-gutters v-if="fieldsLoading">
      <v-col v-for="n in 9" :key="n" cols="12" sm="6" lg="3">
       <v-sheet class="mt-2">
        <v-skeleton-loader class="mx-auto" type="list-item"></v-skeleton-loader>
      </v-sheet>
      </v-col>
    </v-row>
    <form-data :references.sync="formReferences" :model="returnObj" ref="returnRef" v-else>
      <template slot="extraDetails" class="mb-3">
        <v-row>
          <v-col cols="12" class="text-right pt-0 pb-0">
            <v-btn fab x-small color="primary" v-if="showScrollToBottom" @click="goToBottom"><v-icon>mdi-chevron-down</v-icon></v-btn>
          </v-col>
        </v-row>
        <v-form ref="orderItems">
          <v-simple-table dense class="mt-4">
            <template v-slot:default>
              <thead>
                <tr>
                  <th>
                    {{ $t('message.warehouse.product') }}*
                    <v-progress-circular v-if="loadingProducts" indeterminate color="primary"></v-progress-circular>
                  </th>
                  <th>{{ $t('message.whOrder.minQty') }}</th>
                  <th>{{ $t('message.stock.location') }}*</th>
                  <th>{{ $t('message.order.qty') }}*</th>
                  <th v-if="returnObj.status !== 'ordered' && returnObj.status !== 'draft'">
                    {{ $t('message.stock.batchOrWin') }}
                    <v-progress-circular v-if="loadingBatchNumber" indeterminate color="primary"></v-progress-circular>
                  </th>
                  <th v-if="returnObj.status !== 'ordered' && returnObj.status !== 'draft'">{{ $t('message.whOrder.recQty') }} (+/-)</th>
                  <th>{{ $t('message.common.comments') }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(element, index) in orderItems" :key="index" class="pt-4">
                  <v-text-field type="text" class="hidden-sm-and-up hidden-sm-and-down" v-model="element.id"></v-text-field>
                  <td width="25%">
                     <v-autocomplete v-model ="element.productid" :items="element.products" item-text="productName" item-value="id" :rules="$_requiredValidation"
                      @keyup="$event.keyCode !== 13 && $event.keyCode !== 9 ? loadProducts(`searchInput${index}`, index, $event) : ''" autocomplete="off"
                      :ref="`searchInput${index}`" outlined dense
                      @click="toggleAllProducts(index, SHOW)"
                      :loading="element.productLoader"
                      @blur="toggleAllProducts(index, HIDE, element.productid)"
                      @change="getActiveProuct(index, element.productid)" :disabled="disableFields"
                     hide-details full-width :placeholder="$t('message.common.typeHere')"></v-autocomplete>
                  </td>
                  <td width="5%">
                    <span>{{ element.minstock }}</span>
                  </td>
                  <td width="15%">
                    <template v-if="element.adjustorder">
                      <v-autocomplete autocomplete="off"
                        @keyup="$event.keyCode !== 13 ? loadLocation(`searchLocation${index}`, index, $event, element.productid) : ''"
                        :ref="`searchLocation${index}`"
                        @click="toggleLocation(index, SHOW)"
                        @focusout="toggleLocation(index, HIDE, element.adjustorder.locationid)"
                        :disabled="disableFields" v-model="element.adjustorder.locationid"
                        :rules="$_requiredValidation" :items="element.locations"
                        item-text="location_name" item-value="locationid"
                        @change="autoSave()"
                        hide-details full-width outlined dense :placeholder="$t('message.order.searchLocation')">
                        <template v-slot:no-data>
                          <span class="pa-1 caption">{{ $t('message.common.noResults') }}</span>
                        </template>
                      </v-autocomplete>
                      <!-- <v-autocomplete autocomplete="off" :disabled="disableFields" @change="changesMade()" v-model="element.adjustorder.locationid" :rules="$_requiredValidation" :items="element.locations" item-text="location_name" item-value="locationid"
                      hide-details full-width outlined dense :placeholder="$t('message.common.typeHere')"></v-autocomplete> -->
                    </template>
                  </td>
                  <td width="10%">
                    <v-text-field v-model="element.qty" outlined dense :rules="element.qty ? $_norwegianNumberValidation : $_requiredValidation" :disabled="disableFields"
                    @keyup="validateQtyIndex(index)" hide-details full-width :placeholder="$t('message.common.typeHere')" :ref="`qty_${index}`" @change="autoSave()"></v-text-field>
                  </td>
                  <td width="10%" v-if="returnObj.status !== 'ordered' && returnObj.status !== 'draft'">
                    <template v-if="element.isbatch">
                      <v-text-field hide-details dense outlined disabled v-if="returnObj.status === 'received'" v-model="element.adjustorder.batchnumber"></v-text-field>
                      <v-autocomplete v-else autocomplete="off"
                        v-model="element.adjustorder.batchnumber" :disabled="returnObj.status === 'received'"
                        @change="checkQtyOfBatchNumber(index, element.adjustorder.batchnumber)"
                        :rules="$_requiredValidation" :items="element.batch_numbers" item-text="batchnumber_ref" item-value="batchnumber"
                        hide-details full-width outlined dense :placeholder="$t('message.common.typeHere')"></v-autocomplete>
                    </template>
                  </td>
                  <td width="10%" v-if="returnObj.status !== 'ordered' && returnObj.status !== 'draft'">
                    <v-text-field  v-model="element.receivedqty" outlined dense disabled hide-details full-width></v-text-field>
                  </td>
                  <td width="15%">
                    <v-text-field  v-model="element.comments" outlined dense type="text" :disabled="returnObj.status === 'received'" hide-details full-width :placeholder="$t('message.common.typeHere')" @change="changesMade()"></v-text-field>
                  </td>
                  <td width="15%">
                    <v-btn class="mx-2" text fab dark small color="primary" v-if="returnObj.status !== 'received'"
                    @click="deleteProductRow(index, element.id)">
                      <v-icon dark>mdi-minus-circle</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-form>
        <v-btn class="mx-2" fab dark small color="primary" @click="addProductRowHandler" v-if="returnObj.warehouseid && !this.disableFields">
          <v-icon dark>mdi-plus</v-icon>
        </v-btn>
        <v-fab-transition>
          <v-btn fab bottom right color="primary" id="scroll__top" fixed v-if="showScrollToTop" @click="scrollToTop">
            <v-icon dark>mdi-chevron-up</v-icon>
          </v-btn>
        </v-fab-transition>
      </template>
    </form-data>
  </div>
</template>
<script>
/* eslint-disable */
import { mapState } from 'vuex'
import FormTemplate from '../../../components/FormTemplate'
import CONSTANTS from '@/utils/warehouse.json'
import goTo from 'vuetify/lib/services/goto'
export default {
  data () {
    return {
      returnObj: {
        id: this.$route.params.return_id,
        file: [],
        status: 'draft',
        priority: 'medium',
        datePicker: ''
      },
      fieldsLoading: false,
      disableFields: false,
      statusDisable: false,
      loading: false,
      orderItems: [],
      listOfProducts: [],
      loadingProducts: false,
      loadingBatchNumber: false,
      isAutoSave: false,
      showScrollToTop: false,
      showScrollToBottom: false
    }
  },
  components: {
    'form-data': FormTemplate
  },
  computed: {
    ...mapState(['FORM_TYPE', 'listOfWarehouse', 'listOfSuppliers', 'listOfLocations']),
    statusList () {
      if (!this.$route.params.return_id) {
        return [{
          name: this.$t('message.common.draft'), id: CONSTANTS.DRAFT
        }]
      } else if (this.returnObj.status !== CONSTANTS.RECEIVED) {
        return [{
          name: this.$t('message.common.draft'), id: CONSTANTS.DRAFT
        }, {
          name: this.$t('message.common.inProgress'), id: CONSTANTS.INPROGRESS
        }]
      } else {
        return [{
          name: this.$t('message.common.received'), id: CONSTANTS.RECEIVED
        }]
      }
    },
    pageHeight () {
      return document.body.scrollHeight
    },
    formReferences () {
      return {
        title: this.$route.params.return_id ? `${this.$t('message.whOrder.updateReturnOrder')} (${this.returnObj.number || ''})` : this.$t('message.whOrder.addReturnOrder'),
        properties: [{
          model: 'orderdate',
          rules: this.$_requiredValidation,
          type: this.FORM_TYPE.DATEPICKER,
          class: 'lg3 sm6 xs12',
          disabled: this.disableFields,
          picker: 'datePicker',
          menu: 'dateMenu',
          color: 'primary lighten-1',
          label: this.$t('message.whOrder.orderDate'),
          change: this.changesMade
        }, {
          model: 'supplierid',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          rules: [],
          items: this.listOfSuppliers,
          disabled: this.$route.params.return_id ? true : false,
          term: 'supplier',
          click: (term) => null,
          is_list: false,
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.order.supplier'),
          class: 'lg3 sm6',
          change: this.changesMade
        }, {
          model: 'warehouseid',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          rules: this.$_requiredValidation,
          items: this.listOfWarehouse,
          disabled: this.$route.params.return_id ? true : false,
          click: (term) => null,
          is_list: false,
          term: 'warehouse',
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.layout.warehouse'),
          class: 'lg3 sm6',
          change: this.changesMade
        }, {
          model: 'priority',
          type: this.FORM_TYPE.SELECT,
          rules: [],
          items: this.$_priorityList,
          disabled: this.disableFields,
          term: '',
          is_list: true,
          select_text: 'text',
          select_value: 'value',
          label: this.$t('message.layout.priority'),
          class: 'lg3 sm6',
          change: this.changesMade
        }, {
          model: 'status',
          type: this.FORM_TYPE.SELECT,
          rules: [],
          items: this.statusList,
          term: '',
          is_list: true,
          select_text: 'name',
          select_value: 'id',
          disabled: this.statusDisable,
          label: this.$t('message.customer.status'),
          class: 'lg3 sm6',
          change: this.changesMade
        }, {
          model: 'comments',
          type: this.FORM_TYPE.TEXTAREA,
          label: this.$t('message.common.comments'),
          class: 'lg3 sm6',
          change: this.changesMade
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.$route.params.return_id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: () => this.saveWithoutAuto(this.SAVE),
          loading: this.loading,
          is_show: true
        }, {
          name: 'action_handler_update',
          color: 'primary',
          label: this.$t('message.common.updateAndClose'),
          click: () => this.saveWithoutAuto(this.UPDATE_CLOSE),
          loading: this.loading,
          is_show: this.$route.params.return_id
        }, {
          name: 'back_to_list',
          color: 'info',
          // eslint-disable-next-line
          click: () => this.$router.push('/w_h/order'),
          label: this.$t('message.common.backToList'),
          to: '/w_h/order',
          is_show: true
        }, {
          name: 'delete_btn',
          color: 'error',
          label: this.$t('message.common.delete'),
          click: this.deleteHandler,
          disabled: this.statusDisable,
          is_show: this.$route.params.return_id
        }],
        end_buttons: [{
          name: 'download',
          color: 'teal',
          click: () => this.$parent.$parent.printOrder({ ...this.returnObj, type_ref: 'return' }),
          loading: false,
          label: this.$t('message.order.download'),
          class: 'text-right',
          is_show: this.$route.params.return_id
        }, {
          name: 'share',
          color: 'info',
          label: this.$t('message.order.share'),
          click: () => this.$parent.$parent.sendReport({ ...this.returnObj, type_ref: 'return' }),
          loading: false,
          class: 'text-right',
          is_show: this.$route.params.return_id
        }]
      }
    }
  },
  mounted () {
    this.returnObj.orderdate = this.$formatter.formatDate(new Date(), 'YYYY-MM-DD', 'DD.MM.YYYY')
    // this.getProductHandler()
    if (this.returnObj.id) {
      this.getSingleRecordHandler(true)
      this.isAutoSave = this.$route.query.autosave
      window.history.pushState({ path: this.$route.path }, '', this.$route.path)
    }
    if (this.returnObj.id) this.getSingleRecordHandler()
    // this.getProductHandler()
    let text = this.$t('message.common.deleteSuccess')
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.ORDERITEMS) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        if (!data.orderItemsAutoSave) this.getSingleRecordHandler()
      } else {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.$store.commit('isChangesMade', false)
        this.$router.push('/w_h/order')
      }
    })
    // read supporting list items
    this.$store.dispatch('getSupplierList')
    this.$store.dispatch('getWarehouse')
      .then(() => {
        if (!this.returnObj.id) this.setDefaultValues({ prop: 'warehouseid', list: this.listOfWarehouse })
      })
    this.returnObj.type = 'return'
    // this.$store.dispatch('getWarehouseLocations')
  },
  watch: {
    'returnObj.datePicker' (val) {
      if (val) {
        this.returnObj.orderdate = this.$formatter.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    },
    'returnObj.warehouseid' (val) {
      if (val) {
        this.orderItems = []
        this.addProductRowHandler()
      } else {
        this.clearLocationRefForWarehouse()
      }
    },
    'returnObj.status' (val) {
      if (!val || val === CONSTANTS.DRAFT) this.disableFields = false
      else this.disableFields = true
    }
  },
  methods: {
    autoSave () {
      if (this.orderItems.length >= 1) {
        let canSave = true
        this.orderItems.every((element) => {
          if (!element.productid && !element.qty && !element.locationid) {
            canSave = false
            return false
          } else return true
        })
        if (canSave) this.saveUpdateHandler(this.SAVE, true)
      }
    },
    saveWithoutAuto (type) {
      setTimeout(() => {
        if (!this.loading) this.saveUpdateHandler(type)
      }, 300)
    },
    clearLocationRefForWarehouse () {
      let productItems = this.$formatter.cloneVariable(this.orderItems)
      for (let i = 0; i < productItems.length; i++) {
        let productItem = this.orderItems[i]
        productItem.adjustorder.locationid = null
        this.$set(this.orderItems, i, productItem)
      }
    },
    // Searching products
    loadProducts (term, index, event) {
      if ([30, 32, 37, 38, 39, 40].indexOf(event.keyCode) > -1) return
      let searchText = this.$refs[term][0].lazySearch
      if (searchText !== null) {
        let model = {
          'expand': [{
            'model': 'ProductSupplier',
            'on_field': 'productid',
            'on_parent_field': 'id',
            'filter': `supplierid eq ${this.returnObj.supplierid}`
          }, {
            select: ['is_generate_win'],
            model: 'ProductWorkFlow',
            on_field: 'id',
            on_parent_field: 'workflow_id'
          }],
          'filter': `number contains '${searchText}' OR name contains  '${searchText}'`,
          'additionalfilters': [`isactive eq 1`],
          'skip': 0,
          'limit': 50,
          'order_by': {
            'field': 'number',
            'asc_or_desc': 'asc'
          }
        }
        this.$set(this.orderItems, index, { ...this.orderItems[index], productLoader: true })
        this.$_executeApi('post', 'products/query', model).then((response) => {
          this.orderItems[index].products = []
          if (response.data.length > 0) {
            response.data.forEach(element => {
              element.productName = element.number ? `${element.number} - ${element.name}` : element.name
            })
            this.orderItems[index].products = response.data
          }
        }).finally(() => {
          this.$set(this.orderItems, index, { ...this.orderItems[index], productLoader: false })
        })
      }
    },
    addProductRowHandler () {
      this.orderItems.push({ products: [], locationid: 0, adjustorder: {} })
    },
    loadLocation (ref, index, event, productid) {
      if ([32, 37, 38, 39, 40, 30].indexOf(event.keyCode) > -1) return
      let searchText = this.$refs[ref][0].lazySearch
      if (searchText && productid) {
        this.$set(this.orderItems, index, { ...this.orderItems[index], locationLoading: true })
        this.$_executeApi('get', `/stocks/get_warehouse_locations_with_stock?product_id=${productid}&warehouse_id=${this.returnObj.warehouseid}&search_term=${searchText}`)
          .then((result) => {
            let model = result.data
            model = model.filter(x => x.onstock)
            let transformData = { number: { list: ['onstock'], format: 'replaceDotWithComma' } }
            model = this.$_formatListModel(model, transformData)
            model.map(x => {
              x.location_name = `${x.location_name} (${x.onstock})`
              return x
            })
            this.$set(this.orderItems, index, { ...this.orderItems[index], locations: model })
          }).finally(() => {
            this.$set(this.orderItems, index, { ...this.orderItems[index], locationLoading: false })
          })
      }
    },
    toggleLocation (index, action, locationid) {
      let items = this.$formatter.cloneVariable(this.orderItems)
      if (action === this.HIDE && items[index] && items[index].adjustorder && items[index].locations) {
        let locations = items[index].locations.filter(x => x.locationid === locationid)
        items[index].locations = locations
      }
      if (this.orderItems && this.orderItems.length > 0 && this.orderItems[index]) this.$set(this.orderItems, index, items[index])
    },
    // getStockHandler (index, productid) {
    //   return new Promise((resolve, reject) => {
    //     this.$_executeApi('get', `/stocks/get_product_by_warehouse?product_id=${productid}&warehouse_id=${this.returnObj.warehouseid}`)
    //       .then((result) => {
    //         let model = result.data
    //         let transformData = { number: { list: ['on_stock'], format: 'replaceDotWithComma' } }
    //         model = this.$_formatListModel(model, transformData)
    //         model.map(x => {
    //           x.location_name = `${x.location_name} (${x.on_stock})`
    //           return x
    //         })
    //         resolve(model)
    //       })
    //       .catch((err) => {
    //         reject(err)
    //       })
    //   })
    // },
    getBatchNumbersHandler (productid, locationid) {
      return new Promise((resolve, reject) => {
        this.$_executeApi('get', `/warehouseorderitems/get_batchnumbers_by_location?product_id=${productid}&location_id=${locationid}`)
          .then((result) => {
            let model = result.data
            let transformData = { number: { list: ['onstock'], format: 'replaceDotWithComma' } }
            model = this.$_formatListModel(model, transformData)
            model.map(x => {
              x.batchnumber_ref = ''
              x.batchnumber_ref = `${x.batchnumber} ${x.is_defect_batch ? '(B)' : ''} (${x.onstock})`
              return x
            })
            resolve(model)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    getSingleRecordHandler (showLoader) {
      this.fieldsLoading = showLoader
      this.$_getSingleRecordHandler(`${this.WH_ORDER}/${this.returnObj.id}`)
        .then((result) => {
          let transformDate = { date: { list: ['orderdate'], from: 'DD-MM-YYYYTHH:mm:ss', to: 'DD.MM.YYYY' } }
          let model = this.$_formatModel(result.data, transformDate)
          this.returnObj = model
          const getType = this.$_orderType.find(x => x.value === this.returnObj.type)
          const type = getType ? getType.text : this.returnObj.type
          this.returnObj = Object.assign({ ...this.returnObj }, { type })
          if (this.returnObj.status === CONSTANTS.RECEIVED) this.statusDisable = true
          this.getOrderItemsHandler(this.returnObj.id)
        })
    },
    getOrderItemsHandler (id) {
      let url = `warehouseorderitems/get_by_order/${id}`
      this.loadingProducts = true
      this.loadingBatchNumber = true
      this.$_executeApi('get', url)
        .then(async (response) => {
          let data = response.data
          let transformNumber = { number: { list: ['qty', 'onstock', 'minstock', 'receivedqty'], format: 'replaceDotWithComma' }, adjustment: {} }
          data = this.$_formatListModel(data, transformNumber)
          let result = []
          for (let i = 0; i < data.length; i++) {
            data[i].products = []
            data[i].locations = []
            data[i].products.push({
              id: data[i].productid,
              productName: data[i].productnumber ? `${data[i].productnumber} - ${data[i].productname}` : data[i].productname
            })
            data[i].locations.push({
              locationid: data[i].adjustorder.locationid,
              location_name: `${data[i].adjustorder.locationname} (${this.$formatter.replaceDotWithComma(data[i].adjustorder.availablestockqty) || '0, 00'})`
            })
            // data[i].locations = await this.getStockHandler(0, data[i].productid)
            data[i].batch_numbers = await this.getBatchNumbersHandler(data[i].productid, data[i].adjustorder.locationid)
            result.push(data[i])
          }
          this.orderItems = result
          if (this.isAutoSave) {
            setTimeout(() => {
              this.$refs[`qty_${this.orderItems.length - 1}`][0].focus()
              this.isAutoSave = false
            }, 100)
          }
          this.loadingProducts = false
          this.loadingBatchNumber = false
        })
        .finally(() => {
          this.fieldsLoading = false
        })
    },
    saveUpdateHandler (type, autoSave) {
      if (autoSave || this.$refs.returnRef.$refs.validateForm.validate()) {
        if (autoSave ? this.$refs.orderItems && this.$refs.orderItems.validate() : true) {
          this.loading = true
          let transformData = { date: { list: ['orderdate'], from: 'DD.MM.YYYY', to: 'YYYY-MM-DDTHH:mm:ss' } }
          let model = this.$formatter.cloneVariable(this.returnObj)
          model = this.$_formatModel(model, transformData)
          let url = this.WH_ORDER
          model.type = CONSTANTS.RETURN
          this.$_saveUpdateHandler(url, model, false, autoSave)
            .then((response) => {
              this.returnObj.id = response.id
              this.$store.commit('isChangesMade', false)
              this.saveOrderItemsHandler(response.id, type, autoSave)
            })
        }
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    saveOrderItemsHandler (id, type, autoSave) {
      if (this.$refs.orderItems.validate()) {
        let transformData = { number: { list: ['qty', 'onstock', 'receivedqty'], format: 'replaceCommaWithDot' } }
        let model = this.$formatter.cloneVariable(this.orderItems)
        model = this.$_formatListModel(model, transformData)
        let orderItemsJSON = { 'items': this.$formatter.cloneVariable(model) }
        let url = `/warehouseorderitems/bulk_save/${id}`
        this.$_executeApi('post', url, orderItemsJSON).then((response) => {
          if (autoSave) {
            this.orderItems.forEach((element, index) => {
              element.id = response.data[index].id
              element.orderid = id
            })
          }
          // if (this.$route.params.return_id && type !== this.UPDATE_CLOSE && !autoSave) this.getSingleRecordHandler()
          if (!autoSave && type === this.SAVE && id) this.$router.push(`/w_h/order/returnorder/actions/${id}`).catch((err) => console.log(err))
          else if (!autoSave && type === this.UPDATE_CLOSE) this.$router.push('/w_h/order')
          else if (!this.$route.params.return_id) this.$router.push(`/w_h/order/returnorder/actions/${id}?autosave=true`)
          // if (this.$route.params.return_id && type !== this.UPDATE_CLOSE) this.getSingleRecordHandler()
          // else if (!autoSave && type === this.SAVE && id) this.$router.push(`/w_h/order/returnorder/actions/${id}`)
          // else if (!autoSave && type === this.UPDATE_CLOSE) this.$router.push('/w_h/order')
        }).finally(() => {
          this.loading = false
          this.getSingleRecordHandler()
        })
      } else {
        this.loading = false
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
      }
    },
    navigateHandler (type, id) {
      if (this.$route.params.transfer_id && type !== this.UPDATE_CLOSE) this.getSingleRecordHandler()
      else if (type === this.SAVE && id) this.$router.push(`/w_h/order/returnorder/actions/${id}`)
      else if (type === this.UPDATE_CLOSE) this.$router.push('/w_h/order')
    },
    async getActiveProuct (index, productid) {
      this.changesMade()
      let getProduct = this.orderItems[index].products
      if (getProduct) {
        // let stockObjs = []
        let result = getProduct.find(x => x.id === productid)
        if (result && result.ispackage) {
          this.loadingProducts = true
          this.getProductsByPackage(productid, index)
        }
        // else {
        //   stockObjs = await this.getStockHandler(index, productid)
        // }
        let getObj = this.$formatter.cloneVariable(this.orderItems[index])
        getObj.minstock = this.$formatter.replaceDotWithComma(result.minstock || 0)
        getObj.available = this.$formatter.replaceDotWithComma(result.available || 0)
        getObj.isbatch = result.batchrequired || result.productworkflow_is_generate_win
        getObj.adjustorder.locationid = 0
        // getObj.locations = stockObjs
        this.$set(this.orderItems, index, getObj)
      }
    },
    async getProductsByPackage (id, index) {
      let query = {
        select: [],
        expand: [{
          'model': 'Product',
          'on_field': 'id',
          'on_parent_field': 'productid',
          inner_expand: {
            select: ['is_generate_win'],
            model: 'ProductWorkFlow',
            on_field: 'id',
            on_parent_field: 'workflow_id'
          }
        }],
        filter: `packageid eq '${id}'`
      }
      this.$_executeApi('post', 'productpackages/query', query)
        .then(async (response) => {
          let getAllProducts = []
          let list = response.data
          for (let i = 0; i < list.length; i++) {
            let products = [{ id: list[i].product_id, productName: list[i].product_number ? `${list[i].product_number} - ${list[i].product_name}` : list[i].product_name }]
            // let locations = await this.getStockHandler(index, list[i].product_id) || []
            getAllProducts.push({ products,
              productid: list[i].product_id,
              minstock: list[i].product_minstock ? this.$formatter.replaceDotWithComma(list[i].product_minstock) : 0,
              adjustorder: { locationid: 0 },
              isbatch: list[i].product_batchrequired || list[i].productworkflow_is_generate_win,
              // locations: [],
              productName: list[i].product_number ? `${list[i].product_number} - ${list[i].product_name}` : list[i].product_name })
          }
          let getExistingItems = this.$formatter.cloneVariable(this.orderItems)
          getExistingItems.splice(index, 1)
          getExistingItems.push(...getAllProducts)
          this.orderItems = getExistingItems
        })
        .finally(() => {
          this.loadingProducts = false
        })
    },
    checkQtyOfBatchNumber (index, batchNumber) {
      // this.changesMade()
      let getObj = this.$formatter.cloneVariable(this.orderItems[index])
      if (getObj) {
        let getBatch = getObj.adjustorder.batchnumber
        let stockObj = getObj.batch_numbers.find(x => x.batchnumber === getBatch)
        if (stockObj) {
          let stockValue = parseFloat(this.$formatter.replaceCommaWithDot(stockObj.onstock || 0))
          let qty = parseFloat(this.$formatter.replaceCommaWithDot(this.orderItems[index].qty || 0))
          if (stockValue < qty) {
            setTimeout(() => {
              getObj.adjustorder.batchnumber = ''
              this.$set(this.orderItems, index, getObj)
            })
            this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.whOrder.onstockLessMsg') })
          }
        }
      }
    },
    // checkBatchNumber (index, batchNumber) {
    //   this.loadingBatchNumber = true
    //   let getObj = this.$formatter.cloneVariable(this.orderItems[index])
    //   this.$_executeApi('get', `/warehouseorderitems/is_batchnumber_exists?batchNumber=${batchNumber}&productId=${getObj.productid}&locationId=${getObj.adjustorder.locationid}`)
    //     .then(response => {
    //       if (response) {
    //         if (response.data) {
    //           setTimeout(() => {
    //             getObj.adjustorder.batchnumber = ''
    //             this.$set(this.orderItems, index, getObj)
    //           })
    //           this.$root.$emit('snackbar', {
    //             snackbar: true,
    //             color: 'error',
    //             text: this.$t('message.common.batchExists')
    //           })
    //         }
    //       }
    //     })
    //     .finally(() => {
    //       this.loadingBatchNumber = false
    //     })
    // },
    deleteHandler () {
      let ids = [this.returnObj.id]
      let data = { module: this.WH_ORDER, ids }
      let payload = { ids: data.ids, url: `${this.WH_ORDER}/delete_multiple`, module: this.WH_ORDER }
      this.$store.commit('showDeleteDialog', payload)
    },
    supportingList (type, text) {
      const modelName = text
      text = this.$refs.returnRef.$refs[text][0].lazySearch
      let model = { module: type, dialog: true, text, modelName }
      this.$store.commit('supportingList', model)
    },
    validateQtyIndex (index) {
      let getObj = this.$formatter.cloneVariable(this.orderItems[index])
      if (getObj) {
        let getLocationId = getObj.adjustorder.locationid
        let stockObj = getObj.locations.find(x => x.locationid === getLocationId)
        if (stockObj) {
          let stockValue = parseFloat(this.$formatter.replaceCommaWithDot(stockObj.onstock || 0))
          let qty = parseFloat(this.$formatter.replaceCommaWithDot(this.orderItems[index].qty || 0))
          if (stockValue < qty) {
            getObj.qty = ''
            this.$set(this.orderItems, index, getObj)
            this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.whOrder.onstockLessMsg') })
          }
        }
      }
      this.orderItems[index].receivedqty = this.orderItems[index].qty
    },
    deleteProductRow (index, id) {
      if (this.orderItems[index].id) {
        let payload = { ids: [id], url: `${this.ORDERITEMS}/delete_multiple`, module: this.ORDERITEMS, orderItemsAutoSave: this.$route.params.return_id || null }
        this.$store.commit('showDeleteDialog', payload)
      } else this.orderItems.splice(index, 1)
    },
    // Show and Hide products in the array for performence when having more items
    toggleAllProducts (index, action, productId) {
      let items = this.$formatter.cloneVariable(this.orderItems)
      if (action === this.HIDE && items[index].products) {
        let products = items[index].products.filter(x => x.id === productId)
        items[index].products = products
      }
      this.$set(this.orderItems, index, items[index])
      this.autoSave()
    },
    setDefaultValues (data) {
      let { list, prop } = data
      if (list && list.length === 1) {
        let model = Object.assign({ ...this.returnObj }, { [prop]: list[0].id })
        this.returnObj = model
      }
    },
    onScroll () {
      if (window.pageYOffset <= 0) this.showScrollToTop = false
      else this.showScrollToTop = true
      setTimeout(() => {
        this.onResize()
      })
    },
    onResize () {
      this.showScrollToBottom = window.innerWidth > document.documentElement.clientWidth
    },
    scrollToTop () {
      goTo(0)
    },
    goToBottom () {
      goTo(this.pageHeight)
    },
    changesMade () {
      this.$store.commit('isChangesMade', true)
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.$store.state.isChangesMade) {
      next()
    } else {
      this.$store.commit('isChangesMade', true)
      this.$store.commit('changeLostDialog', true)
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
  }
}
</script>
